<!--
<doc lang="markdown">
</doc>


<style scoped lang="scss">
</style>


<template lang="pug">
</template>
-->

<script>
  // "Herança" direta, mantendo a estrutura isolada (arquivos)
  import FileField from '../desktop/file-field.vue'
  export default FileField
</script>
